import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const StatementAllocationBlock = ({
  stmtAllocTitle,
  isEdit,
  isImyLayer,
  beneficialOwner,
  allowLayerAllocationChange,
  details,
  onIncomeAllocationChange,
  displayStatementAllocationValue,
  disabled
}) => {
  const [detailsState, setDetailsState] = useState(details);

  const handleChange = (e) => {
    const { value } = e.target;
    setDetailsState(prevDetails => ({
      ...prevDetails,
      statementAllocation: value,
    }));
    onIncomeAllocationChange(value);
  };

  useEffect(() => {
    setDetailsState(details);
  }, [details]);

  return (/* Statement Allocations */
    <div className="allocation-group">
      <div className="allocation-title">
        {stmtAllocTitle}
      </div>
      {(!isEdit) && <div
        className="allocation-value"
        data-testid="label-allocation-value"
      >
        {displayStatementAllocationValue(beneficialOwner)} %
        </div>}
      {((isEdit && allowLayerAllocationChange) || (isEdit)) && <div
        className="allocation-input"
      >
        <input
          type="number"
          value={ detailsState.statementAllocation }
          onChange={ handleChange }
          data-testid="field-allocation-value"
          disabled={ disabled }
        />
        <span className="percentage-symbol"> %</span>
        </div>}
    </div>);
};

StatementAllocationBlock.propTypes = {
  stmtAllocTitle: PropTypes.string.isRequired,
  isEdit: PropTypes.bool.isRequired,
  isImyLayer: PropTypes.bool.isRequired,
  beneficialOwner: PropTypes.shape().isRequired,
  allowLayerAllocationChange: PropTypes.bool.isRequired,
  details: PropTypes.shape({
    statementAllocation: PropTypes.number
  }).isRequired,
  onIncomeAllocationChange: PropTypes.func.isRequired,
  displayStatementAllocationValue: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};

export default StatementAllocationBlock;
